<template>
  <button class="app__button button" @click="handlerClick" :data-theme="theme">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      x="0px" y="0px"
      viewBox="0 0 202 83"
    >
      <path
        class="button__svg-top"
        d="M101,82.2c-26.2,0-50.9-4.1-69.5-11.6C12.5,62.9,2,52.6,2,41.5c0-11.1,10.5-21.4,
        29.5-29.1C50.1,4.9,74.8,0.8,101,0.8s50.9,4.1,69.5,11.6c19,7.6,29.5,18,29.5,29.1c0,
        11.1-10.5,21.4-29.5,29.1C151.9,78.1,127.2,82.2,101,82.2z"/>
      <path
        class="button__svg-bg"
        d="M101,3.6C75.1,3.6,50.8,7.6,32.5,15C14.6,22.2,4.7,31.6,4.7,41.5c0,9.9,9.8,19.3,27.7,
        26.5c18.3,7.4,42.6,11.4,68.5,11.4s50.2-4.1,68.5-11.4c17.9-7.2,27.7-16.6,27.7-26.5c
        0-9.9-9.8-19.3-27.7-26.5C151.2,7.6,126.9,3.6,101,3.6z"/>
    </svg>

    <span
      class="button__content"
      v-if="content"
      v-html="content"
    >
    </span>
  </button>
</template>

<script>
import audio from '@/scripts/audio';

export default {
  name: 'AppButton',

  props: {
    content: {
      type: String,
      required: true,
    },
    action: {
      type: String,
      required: true,
    },
    actionVariant: {
      type: String,
      required: false,
      default: 'none',
    },
    theme: {
      type: String,
      require: false,
      default: 'orange',
    },
  },

  methods: {
    handlerClick() {
      this.$store.dispatch(this.action);
      audio.play('click');
      audio.play('background');
      if (this.action === 'startGame') {
        if (this.actionVariant === 'none') {
          this.$sendEvent('Play', `V${this.$store.state.currentGame.groupIndex + 1}`);
        } else if (this.actionVariant === 'again') {
          this.$sendEvent('Play Again', `V${this.$store.state.currentGame.groupIndex + 1}`);
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.app__button {
  position: relative;
  padding: calc(var(--unit-vh) * 0.25) calc(var(--unit-vw) * 0.2);

  font-weight: 800;
  @extend %font-size-button;

  span {
    position: relative;
    color: inherit;
  }

  svg {
    position: absolute;
    top: 50%;
    left: 0;
    width: 100%;
    height: auto;

    transform: translateY(-50%) scaleY(0.95) scaleX(1.2);

    transition: transform .6s ease;
  }

  &:hover {
    svg {
      transform: translateY(-50%) scaleY(0.93) scaleX(1.08);
    }
  }

  @at-root .phase & {
    @extend %font-size-button-share;
  }

  .button__svg-bg {
    fill: $color-bg;
  }

  &[data-theme="orange"] {
    .button__svg-top {
      fill: $color-red;
    }
  }
  &[data-theme="blue"] {
    .button__svg-top {
      fill: $color-blue;
    }
  }

  &[data-theme="dark"] {
    .button__svg-bg {
      fill: $color-bg;
    }
    .button__svg-top {
      fill: $color-red;
    }
    span {
      color: $color-red;
    }
  }

  &[data-theme="dark-app"] {
    .button__svg-bg {
      fill: $color-red;
    }
    .button__svg-top {
      fill: $color-bg;
    }
    span {
      color: $color-bg;
      // @extend %font-size-question;
    }

    @include mq(ipadP) {
      .button__svg-bg {
        fill: $color-bg;
      }
      .button__svg-top {
        fill: $color-red;
      }
      span {
        color: $color-red;
      }
    }
  }


  @include mq(ipadP) {
    & svg {
      transform: translateY(-50%) scaleY(0.85);
    }
  }
}
</style>
